import { Component, ViewChild, TemplateRef, ChangeDetectorRef } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { Propietario } from '../../../models/propietario.model';
import { Representante_propietario } from '../../../models/representante_propietario.model';
import { MatDialog } from '@angular/material';
import { Validators, FormBuilder, FormControl } from '@angular/forms';
import { RutValidator } from 'ng2-rut';
import { FormService } from 'src/app/services/form.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { startWith, map } from 'rxjs/operators';

declare var jQuery: any;
declare var $: any;
@Component({
  selector: 'app-propietario-representante',
  templateUrl: './propietario-representante.component.html',
  styleUrls: ['./propietario-representante.component.css'],
  providers: [UserService, FormService]
})
export class PropietarioRepresentanteComponent {

  @ViewChild('confirmarReemplazo') confirmarReemplazoTemplate: TemplateRef<any>;
  @ViewChild('openModal') openModal: TemplateRef<any>;
  @ViewChild('openModalVer') openModalVer: TemplateRef<any>;

  public rut_pro;
  public mail_pro;
  public invalidRut: Boolean;
  public propietarioRepresentante: Representante_propietario;
  public rows = [];
  public actualRow;
  public matcher = new FormService();
  public filteredOptions;
  public nombreComuna = new FormControl('', [Validators.required]);
  options = []
  public selectedPro: number = null;


  constructor(private fb: FormBuilder, private _userService: UserService,
    private rutValidator: RutValidator, private dialog: MatDialog, private spinner: NgxSpinnerService, private cdr: ChangeDetectorRef) {

    this.rut_pro = this.fb.group({
      rut: ['', [Validators.required, this.rutValidator]]
    })


    this.mail_pro = this.fb.group({
      mail: ['', [Validators.pattern(this.regexp), Validators.required, Validators.maxLength(50)]]
    })



    if (!JSON.parse(localStorage.getItem("propietarioRepresentante"))) {
      localStorage.setItem("propietarioRepresentante", JSON.stringify(this.rows));
    } else {
      this.rows = JSON.parse(localStorage.getItem("propietarioRepresentante"));
    }



    this.invalidRut = true;
    this.propietarioRepresentante = { rut: '', nombre: '', apellido_mat: '', apellido_pat: '', nombre_completo: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', recordId: '' };
  }

  regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

  intervalId: any;

  ngOnInit() {
    // Cargar los datos iniciales
    this.loadFromLocalStorage();

    // Revisar periódicamente cambios en el localStorage
    this.intervalId = setInterval(() => {
      this.loadFromLocalStorage();
    }, 1000); // Revisa cada segundo
  }

  ngOnDestroy() {
    // Limpiar el intervalo cuando el componente se destruye
    clearInterval(this.intervalId);
  }

  loadFromLocalStorage() {
    const storedData = JSON.parse(localStorage.getItem('propietarioRepresentante'));
    if (storedData && storedData.length > 0) {
      this.rows = storedData;
      this.cdr.detectChanges();
    }
  }

  ngAfterContentInit() {
    this.getComunas()
    this.filteredOptions = this.nombreComuna.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value))
      );
  }

  private _filter(value: string): string[] {
    const filterValue = ('' + value).toLowerCase();
    return this.options.filter(option => ('' + option).toLowerCase().includes(filterValue));
  }

  get_propietario(rut?, soloVer?) {
    this.propietarioRepresentante.nombre_completo = this.propietarioRepresentante.nombre.toString() + " " + this.propietarioRepresentante.apellido_pat.toString() + " " + this.propietarioRepresentante.apellido_mat.toString()


    this.spinner.show();
    this.cleanData();
    this._userService.getPropietario(rut).subscribe(
      response => {
        if (response.message) {
          this.propietarioRepresentante.rut = rut ? rut : '';
          this.spinner.hide();
          this.dialog.open(this.openModal);
        } else {



          this.propietarioRepresentante.rut = response.rut ? response.rut : '';
          this.propietarioRepresentante.nombre = response.nombre ? response.nombre : '';
          this.propietarioRepresentante.apellido_mat = response.apellido_mat ? response.apellido_mat : '';
          this.propietarioRepresentante.apellido_pat = response.apellido_pat ? response.apellido_pat : '';
          this.propietarioRepresentante.nombre_completo = response.nombre_completo ? response.nombre_completo : '';
          this.propietarioRepresentante.direccion = response.direccion ? response.direccion : '';
          this.propietarioRepresentante.direccion_num = response.direccion_num ? response.direccion_num : '';

          this.propietarioRepresentante.direccion_complemento = response.direccion_complemento ? response.direccion_complemento : '';
          this.propietarioRepresentante.direccion_completa = response.direccion_completa ? response.direccion_completa : '';
          this.propietarioRepresentante.comuna = response.comuna ? response.comuna : '';
          this.propietarioRepresentante.fono = response.fono ? response.fono : '';
          this.propietarioRepresentante.fax = response.fax ? response.fax : '';
          this.propietarioRepresentante.mail = response.mail ? response.mail : '';
          this.propietarioRepresentante.recordId = response.recordId ? response.recordId : '';
          if (soloVer) {
            this.spinner.hide();
            this.dialog.open(this.openModalVer);
          }
          else {
            this.spinner.hide();
            this.dialog.open(this.openModal);
          }
        }

      },
      error => {
        console.log(error)
        this.spinner.hide();
      }
    )
  }




  cleanData() {
    this.propietarioRepresentante = { rut: '', nombre: '', apellido_mat: '', apellido_pat: '', nombre_completo: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', recordId: '' };
    this.rut_pro.reset()
  }

  update_propietario(rut, id) {
    this.get_propietario(rut);
    this.selectedPro = id;
  }



  savePropietario() {
    this.propietarioRepresentante.nombre_completo = this.propietarioRepresentante.nombre.toString() + " " + this.propietarioRepresentante.apellido_pat.toString() + " " + this.propietarioRepresentante.apellido_mat.toString()


    //por si escriben un rut que ya esté ingresado
    for (let x = 0; x < this.rows.length; x++) {
      if (this.propietarioRepresentante.rut == this.rows[x].rut) {
        this.delete_propietario(x);
      }
    }

    //elimina fila cuando la editan
    /*if (this.selectedPro != null) {
        this.delete_propietario(this.selectedPro);
        this.selectedPro = null;
    }*/

    this.spinner.show();
    this._userService.savePropietario(this.propietarioRepresentante).subscribe(
      response => {
        this.spinner.hide();
        if (response.update || response.save) {
          $("#prop_modal").modal("hide");
          const stored = localStorage.getItem("propietarioRepresentante");
          this.rows = stored ? JSON.parse(stored) : [];

          if (this.rows.length > 0) {
            this.dialog.closeAll()
            const dialogRef = this.dialog.open(this.confirmarReemplazoTemplate, {
              width: '400px',
              disableClose: true,
              data: {}
            });

            dialogRef.afterClosed().subscribe(result => {
              if (result === true) {
                console.log("se quiere reemplazar");
                this.newPropietario()
              }
            });
          } else {
            this.newPropietario()
          }

        }
      },
      error => {
        console.log(error)
        this.spinner.hide();

      }
    )


  }

  newPropietario() {
    // Sobrescribir directamente con un solo objeto
    this.rows = [{
      rut: this.propietarioRepresentante.rut,
      nombre: this.propietarioRepresentante.nombre,
      apellido_pat: this.propietarioRepresentante.apellido_pat,
      apellido_mat: this.propietarioRepresentante.apellido_mat,
      nombre_completo: this.propietarioRepresentante.nombre_completo,

      direccion: this.propietarioRepresentante.direccion,
      direccion_num: this.propietarioRepresentante.direccion_num,

      direccion_complemento: this.propietarioRepresentante.direccion_complemento,
      direccion_completa: this.propietarioRepresentante.direccion_completa,
      comuna: this.propietarioRepresentante.comuna,
      fono: this.propietarioRepresentante.fono,
      fax: this.propietarioRepresentante.fax,
      mail: this.propietarioRepresentante.mail,
      recordId: this.propietarioRepresentante.recordId
    }];

    localStorage.setItem("propietarioRepresentante", JSON.stringify(this.rows));

    // Resetear campos y cerrar el diálogo
    this.propietarioRepresentante = { rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', recordId: '' };
    this.rut_pro.reset()
    this.dialog.closeAll();
  }


  delete_propietario(id) {
    for (let x = 0; x < this.rows.length; x++) {
      if (id == x) {
        this.rows.splice(x, 1);
        localStorage.setItem("propietarioRepresentante", JSON.stringify(this.rows));
        this.rows = JSON.parse(localStorage.getItem('propietarioRepresentante'));
      }
    }


  }


  getComunas() {

    if (JSON.parse(localStorage.getItem("comunas"))) {
      if (JSON.parse(localStorage.getItem("comunas")).length > 0) {
        this.options = JSON.parse(localStorage.getItem('comunas'));
      } else {
        this.options = []
      }
    }

    this.filteredOptions = this.nombreComuna.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value))
      );

  }

}
